import { ConcreteEncodable } from "./ConcreteEncodable";

import { ClientImplEncoder } from "../../encoder/ClientImplEncoder";

import * as CubiqTS from "../../index";
import { Client } from "../Client";

export class ClientImpl extends ConcreteEncodable implements Client {
  public static enType: string = "com.bcdfx.model.ClientImpl";

  /*FID=1*/
  public bookingCode: string;
  /*FID=2*/
  public branchCd: string;
  /*FID=3*/
  public clientId: string;
  /*FID=4*/
  public clientName: string;
  /*FID=5*/
  public salesGroup: string;
  /*FID=6*/
  public salesGroupId: CubiqTS.Long | null = null;
  /*FID=7*/
  public straightThroughProcessingFg: boolean;
  /*FID=8*/
  public allowPartialFillFg: boolean;
  /*FID=9*/
  public autoFillEnabled: boolean;
  /*FID=10*/
  public defaultClientComment: string;
  /*FID=11*/
  public defaultPrivateComment: string;
  /*FID=12*/
  public reverseEngineerTPFg: boolean;
  /*FID=13*/
  public reverseEngineerSLFg: boolean;
  /*FID=14*/
  public traderVisibleFg: boolean;
  /*FID=15*/
  public ordersEnabledFg: boolean;
  /*FID=16*/
  public stpAggregationDefaultFg: boolean;
  /*FID=17*/
  public defaultAccountCd: string;
  /*FID=18*/
  public bmForwardPricing: CubiqTS.ForwardPricingType;
  /*FID=19*/
  public algoForwardPricing: CubiqTS.ForwardPricingType;
  /*FID=20*/
  public autoRollFFOrders: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ClientImplEncoder.Instance;
    this.setEncodableType(ClientImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ClientImpl[" +
      "bookingCode=" +
      this.bookingCode +
      "branchCd=" +
      this.branchCd +
      "clientId=" +
      this.clientId +
      "clientName=" +
      this.clientName +
      "salesGroup=" +
      this.salesGroup +
      "salesGroupId=" +
      this.salesGroupId +
      "straightThroughProcessingFg=" +
      this.straightThroughProcessingFg +
      "allowPartialFillFg=" +
      this.allowPartialFillFg +
      "autoFillEnabled=" +
      this.autoFillEnabled +
      "defaultClientComment=" +
      this.defaultClientComment +
      "defaultPrivateComment=" +
      this.defaultPrivateComment +
      "reverseEngineerTPFg=" +
      this.reverseEngineerTPFg +
      "reverseEngineerSLFg=" +
      this.reverseEngineerSLFg +
      "traderVisibleFg=" +
      this.traderVisibleFg +
      "ordersEnabledFg=" +
      this.ordersEnabledFg +
      "stpAggregationDefaultFg=" +
      this.stpAggregationDefaultFg +
      "defaultAccountCd=" +
      this.defaultAccountCd +
      "bmForwardPricing=" +
      this.bmForwardPricing +
      "algoForwardPricing=" +
      this.algoForwardPricing +
      "autoRollFFOrders=" +
      this.autoRollFFOrders +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
